import { HttpResponse } from "@angular/common/http";
import { Provider } from "@angular/core";
import { Observable } from "rxjs";
import { UseCase } from "../../../core/use-case";
import { ReportEvaluationPracticeFiltersDTO } from "../../models/export-report.model";
import { ProjectEvaluationRepository } from "../../repositories/project-evaluation.repository";

export class ExportPracticeReportUseCase
  implements UseCase<ReportEvaluationPracticeFiltersDTO, HttpResponse<Blob>>
{
  constructor(private repo: ProjectEvaluationRepository) {}
  
  execute(filters: ReportEvaluationPracticeFiltersDTO): Observable<HttpResponse<Blob>> {
    return this.repo.exportPracticeReport(filters);
  }
}

const exportPracticeReportUseCaseFactory = (repo: ProjectEvaluationRepository) =>
  new ExportPracticeReportUseCase(repo);

export const exportPracticeReportUseCaseProvider: Provider = {
  provide: ExportPracticeReportUseCase,
  useFactory: exportPracticeReportUseCaseFactory,
  deps: [ProjectEvaluationRepository],
};
